<template>
  <div class="node_model">
    <div :class="{'node_model_box':true,'finish_mode_box':true}">
      <div class="left_box">
        <div class="left_up_line" :style="getStyleFromConfigs(0)"></div>
        <div class="left_down_line" :style="getStyleFromConfigs(1)"></div>
      </div>
      <div class="center_box">
        <div class="left_horiz_line" :style="getStyleFromConfigs(2)"></div>
        <!--  内容区start  -->
        <el-popover
            placement="right-start"
            trigger="hover"
            :close-delay="50"
            :disabled="status !== '0' && status !== '4'"
            >
          <div v-if="status ==='0'" style="display: flex;flex-direction: row;align-items: stretch;font-size: 12px" :style="{'color':jobType === 'app' ? '#276FF5' : '#FF5F1F'}">
            <div style="display: flex;align-items: center;flex-shrink: 0">{{jobType === 'app' ? getLangMsg("soenoderender_001") : getLangMsg("soenoderender_002")}}</div>
            <div style="width: 1px;background: black;margin: 5px 8px" :style="{'background':jobType === 'app' ? '#E0EFFF' : '#FFE7D6'}"></div>
            <div style="display: flex;flex-direction: column">
              <div v-for="item in jobDetails">{{item}}</div>
            </div>
          </div>
          <div v-if="status === '4'" style="display: flex;flex-direction: row;align-items: stretch;font-size: 12px;">
            <div style="color: #FB2323">{{ getLangMsg("soenoderender_003") }}</div>
            <div style="width: 1px;background: #E5E5E5;margin: 5px 8px"></div>
            <div style="display: flex;flex-direction: column;color: #212121">{{message}}</div>
          </div>
          <div slot="reference">
            <div v-if="nodeObj['nodeId']!=null && nodeObj['nodeId'].includes('StartSignal')" class="startNode">
<!--              <div style="width: 16px;height: 16px;border-radius: 50%;display: flex;justify-content: center;align-items: center;background-color: #1BA854">-->
<!--                <div style="width: 10px;height: 10px;border-radius: 50%;display: flex;align-items: center;justify-content: center;overflow: hidden;margin: 0 0 1px 1px">-->
<!--                  <i class="kdfont kdfont-kaishizhihang" style="font-size: 24px;color: #fff"></i>-->
<!--                </div>-->
<!--              </div>-->
              <img :src="startImgUrl" alt="" style="width: 21px">
              <div style="font-size: 12px;margin-left: 2px">{{ getLangMsg("soenoderender_004") }}</div>
            </div>
            <div v-else :class="statusClassMap[status]" :style="getStyleFromConfigs(3)" @click="clickNode(nodeObj)">
              <div class="details">
                <span class="name" :title="nodeObj.name">{{nodeObj.name}}</span>
              </div>
            </div>
          </div>
        </el-popover>
        <!--  内容区end  -->
        <div class="right_horiz_line" :style="getStyleFromConfigs(4)"></div>
      </div>
      <div class="right_box">
        <div class="right_up_line" :style="getStyleFromConfigs(5)"></div>
        <div class="right_down_line" :style="getStyleFromConfigs(6)"></div>
      </div>
    </div>
  </div>
</template>
<script>

export default {
  props: {
    nodeObj:Object,
    index:Number,
    appRemRegId:String,
    invoke:Function,
  },
  computed: {
    configStr:function (){
      if(this.nodeObj && this.nodeObj.nodeType){
        return this.nodeConfigsMap[this.nodeObj.nodeType.toString()];
      }else {
        return null;
      }
    },
    status:function (){
      if(this.nodeObj && this.nodeObj.nodeInfo){
        let isIng,isNoStart,isFinish,isStop;
        this.nodeObj.nodeInfo.forEach(function(item){
          if(item.status === '0'){
            isIng = true;
          } else if(item.status === '1'){
            isFinish = true;
          } else if(item.status === '2'){
            isNoStart = true;
          } else if(item.status === '4'){
            isStop = true;
          }
        })
        if(isStop){
          return '4'
        }else if(isIng){
          return '0'
        }else if(isNoStart){
          return '2'
        }else if(isFinish){
          return '1'
        }
      }else {
        return "";
      }
    },
    jobType:function (){
      if(this.nodeObj && this.nodeObj.nodeInfo){
        return this.nodeObj.nodeInfo[0].appRemType;
      }else {
        return "";
      }
    },
    message:function (){
      if(this.nodeObj && this.nodeObj.nodeInfo){
        return this.nodeObj.nodeInfo[0].result;
      }else {
        return "";
      }
    },
    jobDetails:function (){
      if(this.nodeObj && this.nodeObj.nodeInfo){
        let jobArr = [];
        this.nodeObj.nodeInfo.forEach(function (item){
          jobArr.push(item.positionName);
        })
        return jobArr;
      }else {
        return null;
      }
    }
  },
  watch: {

  },
  data() {
    return {
      statusClassMap:{
        '0':'content_ing',
        '1':'content_finish',
        '2':'content_nostart',
        '4':'content_nopass'
      },
      startImgUrl:"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACkAAAAiCAYAAADCp/A1AAAABmJLR0QA/wD/AP+gvaeTAAADx0lEQVRYw82YSUxTURSG/0KJPJAApWgrhhLbOqGWomAiDokmUHXhhHOcQJegRjfEAZEIqDsxJg6AiUqMC904VBeoUCOoiC0GojwHhGeLErAWWvCV1gXS1MgbW9R/1bx373lf/nPuvedWQv7o9OI/V8i/BuAjaTCCkHYKJutrAEBbbwf63APQx2sBAIqIWGQoZyMqjBAdXyI23TZnD6pajTB9tqCPHuAcnxKvwXJVOgyJ6WMP6aBdOGu5BWP7M1GupMRrsHOGAXq5ZmwgSTuFQ08rYHP2iAL0V55uDbLVS4ILWWdtRtmLa7xSy1cGVToK5m7hHMdrdZN2KuiAAGBsf4bSxurAIR20C3try1kBI6XhAYFy1Tcn5OH6CkbASGk4CvU70bjqAo6n5oiGLW2sZq1zVsimbhKvvpKM7y9mHMSeqSsxXkpgl9aAm8uKsUShEwVa2XJPHOTlViNrYEVEnO+3BBIkxyThfMYBUa7e//QcpJ0SBmlz9rC66C/a44aDdgJAQK7e/dggDLLO2sw7+KCHxrGmy6ixNsHtHRLt6qvudwIhKYsgF9yeIWyvLcGRl5X4MvBNlKvv7NSoCyjoXdAV8gE2PixCXZdFlKtWIZBmBuv5qO17JzY/KsYJ81V0D9pFuTqmTvrr4pvbWF9zDA1fW+HxenyunluwH6sTF446p6v/L6TbX0pChn3J2dDHaREiGf7UwNAP3Omox93O+lHnTIyU/fGMsenVydUBpXzTlKU4MGsDlMTwXuqFFx8dNhSbr+AB9VxQLEbI8SI7aSUhQ1FqDjIT5kEqCfW5d/19DUot19DvZm9SlBECnNRP0OLJrysBX23TZGJ/8npMCI/xudfyrR0l5qt4bDNzzldHT4JCCOQi5WycNd/iBRcqCUHutJWYGaPyudfnduHGh0c4aanmdG9EKQzdOiOkIkLGuy6J0HGYEzvF597r3g8os1Tzcs9fK5Lmj/qcdXXvmrmcNWiX6/ft4jvtRFWbEdk1hYIBsxLToIlOEA6pl2ugk6sZ3+82ncalt3fghRfNve+RazqFoy8reafXXzkshnDecRy0CxuNRehn6cwVhAw2l/jLWcHcLTComK+6nJt5VBiBM4vzEBnGfOYGArhOvZgVkBckAGiiE1AwbysrqBhlJaYhX7eWc5zge3d+bTlr6vlqx/Qs1joUDQkM12i5+SbufxJ2tI1oIhGLkgW7GVdyUCBHZHP2oLLlHkzWZl7O6uRqrFDN56y/oEL6i7RTqP3VyZN2Cn20y3d6aGMnI0Wu+Tf/qv1N/QSX0KZQWjwrzgAAAABJRU5ErkJggg=="
    }
  },
  mounted() {

  },
  methods: {
    getStyleFromConfigs(index){
      if(index === 2 || index === 4){
        return {
          "opacity":this.configStr && this.configStr[index] === '1' ? '1' : '0'
        }
      }else if(index === 3){
        return {
          "display":this.configStr && this.configStr[index] === '1' ? 'flex' : 'none'
        }
      }else {
        return {
          "width":this.configStr && this.configStr[index] === '1' ? 'var(--line-width)' : '0px'
        }
      }
    },
    clickNode(nodeObj){
      nodeObj.appRemRegId=this.appRemRegId;
      nodeObj.aa = Math.random();
      console.log("lll",nodeObj);
      this.invoke('form_clickNode',nodeObj);
    }
  }
}
</script>
<style lang="less">
.node_model{
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: stretch;
  font-size: 12px;
  .node_model_box{
    display: flex;
    height: 100%;
  }
  .finish_mode_box{
    .left_up_line,.left_down_line,.left_horiz_line,.right_horiz_line,.right_up_line,.right_down_line{
      background-color: #ccc !important;
    }
  }
  .left_box{
    display: flex;
    flex-direction: column;
    flex-grow: 0;
    flex-shrink: 0;
    .left_up_line,.left_down_line{
      width: var(--line-width);
      flex-grow: 1;
      flex-shrink: 1;
      background-color: #CCCCCC;
    }
  }
  .center_box{
    display: flex;
    flex-direction: row;
    flex-shrink: 1;
    flex-grow: 1;
    justify-content: center;
    align-items: center;
    .left_horiz_line,.right_horiz_line{
      height:  var(--line-width);
      flex-shrink: 1;
      flex-grow: 1;
      background-color: #CCCCCC;
    }
    .content_ing{
      background-color: #E0EFFF;
      border: 1px solid #B3D5FF;
      color: #104CCC;
    }
    .content_finish{
      background-color: #DCFAE4;
      border: 1px solid #A1E6B5;
      color: #0A803D;
    }
    .content_nostart{
      background-color: #FFFFFF;
      border: 1px solid #D9D9D9;
      color: #212121;
    }
    .content_nopass{
      background-color: #FFDBE0;
      border: 1px solid #FFADB6;
      color: #FB2323;
    }
    .startNode{
      width:var(--box-wight);
      height: var(--box-height);
      display: flex;
      justify-content: center;
      align-items: center;
      flex-grow: 0;
      flex-shrink: 0;
      background-color: #DCFAE4;
      border: 1px solid #A1E6B5;
      color: #0A803D;
    }
    .content_ing,.content_finish,.content_nostart,.content_nopass{
      width:var(--box-wight);
      height: var(--box-height);
      border-radius: 2px;
      display: flex;
      justify-content: center;
      align-items: center;
      flex-grow: 0;
      flex-shrink: 0;
      cursor: pointer;
      .details{
        display: flex;
        flex-direction: column;
        align-items: stretch;
        flex-shrink: 1;
        flex-grow: 0;
        min-width: 10px;
        max-width: var(--content-max-width);
        .name{
          font-size: 12px;
          overflow: hidden;
          text-align: center;
          text-overflow: ellipsis;
        }
      }
    }
  }
  .right_box{
    display: flex;
    flex-direction: column;
    flex-grow: 0;
    flex-shrink: 0;
    .right_up_line,.right_down_line{
      width:  var(--line-width);
      flex-grow: 1;
      flex-shrink: 1;
      background-color: #CCCCCC;
    }
  }
}
.el-popover{
  box-shadow: 0px 4px 10px 0px rgba(0,0,0,0.2);
  border: 0;
  background: #FFFFFF;
  padding: 9px 12px;
  min-width: 100px;
  max-width: 400px;
}
</style>